import classNames from 'classnames';

export const VerticalDivider: React.FC<{ className?: string }> = ({ className }) => {
  return <div className={classNames('bg-linear-to-b bg-gray h-full w-[0.0938rem] my-3', className)} />;
};
